export const EVENT_LABELS = {
  streamStarted: {label: 'Stream iniciado', color: 'success'},
  streamEnded: {label: 'Stream finalizado', color: 'default'},
  streamCrashed: {label: 'Stream crashed', color: 'error'},
  limitEntered: {label: 'Pantalla limite', color: 'warning'},
  limitExited: {label: 'Salio de limite', color: 'default'},
  limitFallbackToRealChannel: {label: 'Fallback a canal real', color: 'info'},
  slotFreed: {label: 'Slot liberado', color: 'success'},
  upstreamConnected: {label: 'Upstream conectado', color: 'info'},
  upstreamStallDetected: {label: 'Corte upstream detectado', color: 'warning'},
  upstreamRecoveryStarted: {label: 'Recuperacion upstream', color: 'warning'},
  upstreamRecoverySucceeded: {label: 'Recuperado', color: 'success'},
  upstreamRecoveryFailed: {label: 'Recuperacion fallida', color: 'error'},
  maxRecoveriesReached: {label: 'Max. recuperaciones', color: 'error'},
  upstreamBlocked: {label: 'Upstream bloqueado', color: 'error'},
  clientDisconnected: {label: 'Cliente desconectado', color: 'warning'},
  remoteCloseRequested: {label: 'Cierre remoto', color: 'warning'},
  heartbeatTick: {label: 'Heartbeat', color: 'default'},
  connectionRegistered: {label: 'Conexion registrada', color: 'info'},
  connectionReleased: {label: 'Conexion liberada', color: 'default'},
  ghostConnectionCleaned: {label: 'Conexion fantasma limpiada', color: 'warning'},
  notifierSent: {label: 'Notificacion enviada', color: 'info'},
  httpRequestCompleted: {label: 'HTTP request', color: 'default'},
  playerCSessionRequested: {label: 'C: sesion solicitada', color: 'info'},
  playerCSessionCreated: {label: 'C: sesion creada', color: 'success'},
  playerCRelayUnavailable: {label: 'C: relay no disponible', color: 'warning'},
  playerCSessionRejected: {label: 'C: sesión rechazada', color: 'error'},
  'frontend:player.selected': {label: 'FE: canal seleccionado', color: 'info'},
  'frontend:player.unselected': {label: 'FE: canal cerrado', color: 'default'},
  'frontend:player.stateChanged': {label: 'Player: cambio de estado', color: 'info'},
  'frontend:player.retryScheduled': {label: 'Player: reconexión programada', color: 'warning'},
  'frontend:player.retryNow': {label: 'Player: reintento inmediato', color: 'info'},
  'frontend:player.recovered': {label: 'Player: señal recuperada', color: 'success'},
  'frontend:player.autoplayBlocked': {label: 'Player: espera interacción', color: 'warning'},
  'frontend:player.terminalError': {label: 'Player: error permanente', color: 'error'},
  'frontend:player.offline': {label: 'Player: sin conexión', color: 'warning'},
  'frontend:player.online': {label: 'Player: conexión restaurada', color: 'success'},
  'frontend:player.userPlay': {label: 'Player: reproducir', color: 'default'},
  'frontend:player.userPause': {label: 'Player: pausa', color: 'default'},
  'frontend:player.variantRefresh': {label: 'Player: revisando variante', color: 'info'},
  'frontend:player.variantChanged': {label: 'Player: variante actualizada', color: 'warning'},
  'frontend:player.variantResolved': {label: 'Player: variante resuelta', color: 'info'},
  'frontend:mpegts.error': {label: 'FE: error mpegts', color: 'error'},
  'frontend:mpegts.mediaInfo': {label: 'FE: mediaInfo', color: 'success'},
  'frontend:mpegts.firstMediaInfo': {label: 'FE: primer mediaInfo', color: 'success'},
  'frontend:mpegts.playerCreated': {label: 'FE: player creado', color: 'info'},
  'frontend:mpegts.createPlayerFailed': {label: 'FE: player fallo', color: 'error'},
  'frontend:mpegts.retryScheduled': {label: 'FE: retry programado', color: 'warning'},
  'frontend:mpegts.maxRetriesReached': {label: 'FE: max retries', color: 'error'},
  'frontend:mpegts.loadingComplete': {label: 'FE: carga completa', color: 'default'},
  'frontend:mpegts.recovered': {label: 'FE: recuperado', color: 'success'},
  'frontend:mpegts.stalled': {label: 'FE: stalled', color: 'warning'},
  'frontend:mpegts.loadTimeout': {label: 'FE: timeout carga', color: 'warning'},
  'frontend:mpegts.destroying': {label: 'FE: destruyendo player', color: 'default'},
  'frontend:video.waiting': {label: 'FE: video esperando', color: 'warning'},
  'frontend:video.stalled': {label: 'FE: video stalled', color: 'warning'},
  'frontend:video.playing': {label: 'FE: video reproduciendo', color: 'success'},
  'frontend:video.pause': {label: 'FE: video pausado', color: 'default'},
  'frontend:video.error': {label: 'FE: error video', color: 'error'},
  'frontend:video.ended': {label: 'FE: video terminado', color: 'default'},
  'frontend:video.ratechange': {label: 'FE: cambio velocidad', color: 'default'},
  'frontend:video.seeking': {label: 'FE: seeking', color: 'default'},
  'frontend:video.seeked': {label: 'FE: seeked', color: 'default'},
  'frontend:video.volumechange': {label: 'FE: volumen', color: 'default'},
  'frontend:slotAvailable.scheduled': {label: 'FE: slotAvailable reconectar', color: 'warning'},
  'frontend:slotAvailable.ignored': {label: 'FE: slotAvailable ignorado', color: 'default'},
  'frontend:engine.selected': {label: 'FE: motor seleccionado', color: 'info'},
  'frontend:anticut.playerCreated': {label: 'AC: player creado', color: 'info'},
  'frontend:anticut.createPlayerFailed': {label: 'AC: player fallo', color: 'error'},
  'frontend:anticut.startupTimeout': {label: 'AC: timeout de arranque', color: 'warning'},
  'frontend:anticut.stallDetected': {label: 'AC: congelacion detectada', color: 'warning'},
  'frontend:anticut.restartScheduled': {label: 'AC: reinicio programado', color: 'warning'},
  'frontend:anticut.restarted': {label: 'AC: reiniciado', color: 'info'},
  'frontend:anticut.recovered': {label: 'AC: recuperado', color: 'success'},
  'frontend:anticut.mpegtsError': {label: 'AC: error mpegts', color: 'error'},
  'frontend:anticut.loadingComplete': {label: 'AC: upstream cerro stream', color: 'warning'},
  'frontend:anticut.slotAvailable.scheduled': {
    label: 'AC: slotAvailable reconectar',
    color: 'warning'
  },
  'frontend:anticut.slotAvailable.ignored': {label: 'AC: slotAvailable ignorado', color: 'default'},
  'frontend:anticut.userPlay': {label: 'AC: play usuario', color: 'default'},
  'frontend:anticut.userPause': {label: 'AC: pausa usuario', color: 'default'},
  'frontend:ultra.stabilizing': {label: 'Ultra: estabilizando', color: 'info'},
  'frontend:ultra.playerCreated': {label: 'Ultra: player creado', color: 'info'},
  'frontend:ultra.manifestParsed': {label: 'Ultra: manifiesto listo', color: 'success'},
  'frontend:ultra.bufferReady': {label: 'Ultra: colchon listo', color: 'success'},
  'frontend:ultra.autoplayBlocked': {label: 'Ultra: autoplay bloqueado', color: 'warning'},
  'frontend:ultra.recovering': {label: 'Ultra: recuperando', color: 'warning'},
  'frontend:ultra.recovered': {label: 'Ultra: recuperado', color: 'success'},
  'frontend:ultra.hlsError': {label: 'Ultra: error HLS', color: 'error'},
  'frontend:ultra.restartScheduled': {label: 'Ultra: reinicio programado', color: 'warning'},
  'frontend:ultra.restarted': {label: 'Ultra: reiniciado', color: 'info'},
  'frontend:ultra.nativeFallback': {label: 'Ultra: HLS nativo', color: 'info'},
  'frontend:ultra.hlsUnsupported': {label: 'Ultra: HLS no soportado', color: 'error'},
  'frontend:ultra.userPlay': {label: 'Ultra: play usuario', color: 'default'},
  'frontend:ultra.userPause': {label: 'Ultra: pausa usuario', color: 'default'},
  'frontend:ultra.compatibilityFallback': {label: 'Ultra: modo compatible', color: 'warning'},
  'frontend:ultra.compatibilityReady': {label: 'Ultra: compatible listo', color: 'success'},
  'frontend:ultra.compatibilityRejected': {label: 'Ultra: compatible descartado', color: 'warning'},
  'frontend:ultra.compatibilityError': {label: 'Ultra: error compatible', color: 'error'},
  'frontend:ultra.timelineReset': {label: 'Ultra: reajuste de línea de tiempo', color: 'default'},
  'frontend:ultra.discontinuity': {label: 'Ultra: discontinuidad HLS', color: 'default'},
  'frontend:ultra.reloadInPlace': {label: 'Ultra: recarga sin reinicio', color: 'warning'},
  'frontend:ultra.relayRecoveryObserved': {label: 'Ultra: relay recuperando', color: 'info'},
  'frontend:ultra.endedIgnored': {label: 'Ultra: fin ignorado (directo)', color: 'default'},
  'frontend:ultra.restartCoalesced': {label: 'Ultra: reinicio agrupado', color: 'default'},
  'frontend:ultra.resumedAtSequence': {label: 'Ultra: reanudado en secuencia', color: 'success'},
  'frontend:d.stabilizing': {label: 'D: estabilizando', color: 'info'},
  'frontend:d.playerCreated': {label: 'D: player creado', color: 'info'},
  'frontend:d.manifestParsed': {label: 'D: manifiesto listo', color: 'success'},
  'frontend:d.bufferReady': {label: 'D: colchón listo', color: 'success'},
  'frontend:d.frozen': {label: 'D: imagen congelada', color: 'warning'},
  'frontend:d.frozenChipShown': {label: 'D: aviso reconectando visible', color: 'info'},
  'frontend:d.resumed': {label: 'D: reanudado sin corte', color: 'success'},
  'frontend:d.resumeNudge': {label: 'D: salto de hueco al reanudar', color: 'info'},
  'frontend:d.discontinuity': {label: 'D: discontinuidad HLS', color: 'default'},
  'frontend:d.timelineReset': {label: 'D: reajuste de línea de tiempo', color: 'default'},
  'frontend:d.hlsError': {label: 'D: error HLS', color: 'error'},
  'frontend:d.reloadInPlace': {label: 'D: recarga sin reinicio', color: 'warning'},
  'frontend:d.reloadPlaylist': {label: 'D: recarga de playlist', color: 'warning'},
  'frontend:d.restartScheduled': {label: 'D: reinicio programado', color: 'warning'},
  'frontend:d.restarted': {label: 'D: reiniciado', color: 'info'},
  'frontend:d.restartCoalesced': {label: 'D: reinicio agrupado', color: 'default'},
  'frontend:d.resumedAtSequence': {label: 'D: reanudado en secuencia', color: 'success'},
  'frontend:d.recovered': {label: 'D: recuperado', color: 'success'},
  'frontend:d.statusLost': {label: 'D: estado del relay perdido', color: 'warning'},
  'frontend:d.statusRecovered': {label: 'D: estado del relay recuperado', color: 'success'},
  'frontend:d.endedIgnored': {label: 'D: fin ignorado (directo)', color: 'default'},
  'frontend:d.autoplayBlocked': {label: 'D: autoplay bloqueado', color: 'warning'},
  'frontend:d.userPlay': {label: 'D: play usuario', color: 'default'},
  'frontend:d.userPause': {label: 'D: pausa usuario', color: 'default'},
  'frontend:d.hlsUnsupported': {label: 'D: HLS no soportado', color: 'error'},
  'frontend:d.nativeFallback': {label: 'D: HLS nativo', color: 'info'},
  'frontend:d.screenLimitShown': {label: 'D: gestor de pantallas', color: 'warning'},
  'frontend:d.screensLoaded': {label: 'D: pantallas cargadas', color: 'info'},
  'frontend:d.screenListError': {label: 'D: error lista de pantallas', color: 'warning'},
  'frontend:d.screenKickRequested': {label: 'D: cierre de pantalla pedido', color: 'info'},
  'frontend:d.screenKickFailed': {label: 'D: cierre de pantalla fallido', color: 'error'},
  'frontend:d.screenSlotFreed': {label: 'D: pantalla liberada', color: 'success'},
  'frontend:d.slotSignal': {label: 'D: aviso de hueco (websocket)', color: 'info'},
  'websocket:websocket.listening': {label: 'WS: servidor listo', color: 'info'},
  'websocket:socket.connected': {label: 'WS: socket conectado', color: 'info'},
  'websocket:socket.disconnected': {label: 'WS: socket desconectado', color: 'default'},
  'websocket:socket.error': {label: 'WS: error socket', color: 'error'},
  'websocket:engine.connection_error': {label: 'WS: error conexion', color: 'error'},
  'websocket:event.frontend.login': {label: 'WS: login frontend', color: 'info'},
  'websocket:event.frontend.unregistered': {label: 'WS: frontend baja', color: 'default'},
  'websocket:event.frontend.unknownKey': {label: 'WS: frontend unknown', color: 'warning'},
  'websocket:event.reloadPlayers.received': {label: 'WS: reload recibido', color: 'info'},
  'websocket:event.reloadPlayers.forwarded': {label: 'WS: reload enviado', color: 'success'},
  'websocket:event.reloadPlayers.noTarget': {label: 'WS: reload sin destino', color: 'warning'},
  'websocket:event.slotAvailable.received': {label: 'WS: slot recibido', color: 'info'},
  'websocket:event.slotAvailable.forwarded': {label: 'WS: slot enviado', color: 'success'},
  'websocket:event.slotAvailable.noTarget': {label: 'WS: slot sin destino', color: 'warning'},
  'websocket:event.internal.unknownKey': {label: 'WS: internal unknown', color: 'warning'},
  'relay:sessionCreated': {label: 'Relay: sesion creada', color: 'success'},
  'relay:slotWaiting': {label: 'Relay: esperando slot', color: 'warning'},
  'relay:slotAcquired': {label: 'Relay: slot adquirido', color: 'success'},
  'relay:ffmpegStarted': {label: 'Relay: ffmpeg iniciado', color: 'info'},
  'relay:upstreamStallDetected': {label: 'Relay: corte upstream', color: 'warning'},
  'relay:ffmpegExited': {label: 'Relay: ffmpeg finalizado', color: 'warning'},
  'relay:ffmpegRestartScheduled': {label: 'Relay: reinicio programado', color: 'warning'},
  'relay:ffmpegProcessError': {label: 'Relay: error de proceso', color: 'error'},
  'relay:catalogReadFailed': {label: 'Relay: error de catálogo', color: 'warning'},
  'relay:bufferReady': {label: 'Relay: buffer listo', color: 'success'},
  'relay:upstreamRecoverySucceeded': {label: 'Relay: upstream recuperado', color: 'success'},
  'relay:spliceContinuous': {label: 'Relay: empalme continuo', color: 'success'},
  'relay:spliceDiscontinuity': {label: 'Relay: empalme con discontinuidad', color: 'warning'},
  'relay:segmentReplayDropped': {label: 'Relay: repetición descartada', color: 'info'},
  'relay:keyframeSplitFallback': {label: 'Relay: corte por tiempo (sin keyframes)', color: 'warning'},
  'relay:slotReleased': {label: 'Relay: slot liberado', color: 'default'},
  'relay:slotReleaseFailed': {label: 'Relay: fallo liberando slot', color: 'error'},
  'relay:remoteCloseRequested': {label: 'Relay: cierre remoto', color: 'warning'},
  'relay:leaseLost': {label: 'Relay: lease perdido', color: 'warning'},
  'relay:leaseConfirmationExpired': {label: 'Relay: lease sin confirmar', color: 'warning'},
  'relay:sessionTickFailed': {label: 'Relay: tick fallido', color: 'warning'},
  'relay:sessionEnded': {label: 'Relay: sesion finalizada', color: 'default'}
};

export function eventLabel(name) {
  if (!name) return {label: '(sin evento)', color: 'default'};
  if (EVENT_LABELS[name]) return EVENT_LABELS[name];
  if (name.startsWith('frontend:')) {
    return {label: name.replace('frontend:', 'FE: '), color: 'info'};
  }
  if (name.startsWith('websocket:')) {
    return {label: name.replace('websocket:', 'WS: '), color: 'info'};
  }
  if (name.startsWith('relay:')) {
    return {label: name.replace('relay:', 'Relay: '), color: 'info'};
  }
  return {label: name, color: 'default'};
}

export function eventSource(event) {
  const eventName = String(event && event.event ? event.event : '');
  const svc = String(event && event.svc ? event.svc : 'backend');
  if (svc === 'websocket') return 'websocket';
  if (svc === 'relay' || eventName.startsWith('relay:')) return 'relay';
  if (eventName.startsWith('frontend:')) return 'frontend';
  return 'backend';
}

export function stableEventId(event) {
  if (event && event._id) return String(event._id);
  return [
    event && event.ts,
    event && event.svc,
    event && event.event,
    event && event.vid,
    event && event.pp,
    event && event.ch,
    JSON.stringify((event && event.attrs) || {})
  ].join('|');
}

export function compareEventsDesc(a, b) {
  const tsCmp = String(b.ts || '').localeCompare(String(a.ts || ''));
  if (tsCmp !== 0) return tsCmp;
  return stableEventId(b).localeCompare(stableEventId(a));
}

export function compareEventsAsc(a, b) {
  const tsCmp = String(a.ts || '').localeCompare(String(b.ts || ''));
  if (tsCmp !== 0) return tsCmp;
  return stableEventId(a).localeCompare(stableEventId(b));
}

export function mergeEvents(currentEvents, incomingEvents, limit = 5000) {
  const byId = new Map();
  [...(currentEvents || []), ...(incomingEvents || [])].forEach((event) => {
    if (!event || typeof event !== 'object') return;
    byId.set(stableEventId(event), event);
  });
  return Array.from(byId.values()).sort(compareEventsDesc).slice(0, limit);
}

export function latestCursor(events) {
  return (events || []).reduce((cursor, event) => {
    const ts = event && event.ts;
    return typeof ts === 'string' && (!cursor || ts > cursor) ? ts : cursor;
  }, null);
}

export function groupEventsBySession(events) {
  const groups = new Map();
  (events || []).forEach((event) => {
    const viewId = event.vid || '';
    if (!groups.has(viewId)) {
      groups.set(viewId, {
        viewId: event.vid || null,
        publicPath: event.pp || null,
        channelName: event.ch || null,
        startedAt: event.ts || null,
        lastEventAt: event.ts || null,
        events: []
      });
    }
    const group = groups.get(viewId);
    group.events.push(event);
    if (event.pp && !group.publicPath) group.publicPath = event.pp;
    if (event.ch && !group.channelName) group.channelName = event.ch;
    if (event.ts && (!group.startedAt || event.ts < group.startedAt)) group.startedAt = event.ts;
    if (event.ts && (!group.lastEventAt || event.ts > group.lastEventAt))
      group.lastEventAt = event.ts;
  });

  return Array.from(groups.values())
    .map((group) => ({
      ...group,
      events: group.events.sort(compareEventsAsc),
      diagnostics: sessionDiagnostics(group.events)
    }))
    .sort((a, b) => String(b.lastEventAt || '').localeCompare(String(a.lastEventAt || '')));
}

export function sessionDiagnostics(events) {
  const diagnostics = [];
  const ordered = [...(events || [])].sort(compareEventsAsc);
  const limitEntered = ordered.find((event) => event.event === 'limitEntered');
  const limitExited = ordered.find((event) => event.event === 'limitExited');

  if (limitEntered && limitExited) {
    const waited = Number(limitExited.attrs && limitExited.attrs.waited);
    if (Number.isFinite(waited) && waited >= 30) {
      diagnostics.push({
        key: 'limitSlow',
        label: `Limite ${Math.round(waited)}s`,
        color: 'warning'
      });
    }
  }
  if (ordered.some((event) => event.event === 'upstreamRecoveryFailed')) {
    diagnostics.push({key: 'recoveryFailed', label: 'Recovery fallo', color: 'error'});
  }
  if (
    ordered.some(
      (event) =>
        event.event === 'maxRecoveriesReached' ||
        event.event === 'frontend:mpegts.maxRetriesReached'
    )
  ) {
    diagnostics.push({key: 'maxRetries', label: 'Max retries', color: 'error'});
  }
  if (ordered.some((event) => String(event.event || '').endsWith('.noTarget'))) {
    diagnostics.push({key: 'wsNoTarget', label: 'WS sin destino', color: 'warning'});
  }

  return diagnostics;
}
